const Advantages = () => {
  const advantages = [
    {
      title: "✅ Полный контроль над бизнесом",
      description: "Управляйте клиентами, заказами и турпакетами в одном удобном интерфейсе."
    },
    {
      title: "✈️  Гибкое создание турпакетов",
      description: "Формируйте динамические туры с разными вариантами отелей, рейсов и услуг."
    },
    {
      title: "📊 Мощная аналитика и статистика",
      description: "Отслеживайте продажи, загруженность туров и поведение клиентов для принятия правильных решений."
    },
    {
      title: "💳 Оптимизированная работа с платежами",
      description: "Поддержка различных способов оплаты и учет финансов в одном месте."
    },
    {
      title: "⚡ Автоматизация процессов",
      description: "Минимизируйте ручную работу благодаря умному управлению бронированиями и клиентами.",
    },
    {
      title: "🔍 Прозрачность и контроль поездок",
      description: "Следите за статусами поездок и обеспечивайте высокий уровень сервиса для паломников."
    },
    {
      title: "📱 Доступ с любого устройства",
      description: "Работайте из офиса или в дороге — наша платформа доступна на компьютере и мобильных устройствах."
    },
    {
      title: "🆘 Безопасность туристов",
      description: "Кнопка SOS для экстренной помощи и система поиска заблудившихся паломников."
    },
    {
      title: "🔔 Автоматические уведомления",
      description: "Информируйте туристов о начале поездки, изменениях статуса и важных событиях через Whatsapp и Push уведомления"
    },
    {
      title: "🗺️ Удобные инструменты для гидов",
      description: "Гиды могут отслеживать геолокацию туристов, просматривать их информацию и оперативно помогать."
    },
    {
      title: "🛂 Автоматическая проверка документов",
      description: "Система отслеживает сроки действия паспортов и виз туристов и уведомляет об их истечении."
    },
    {
      title: "💾 Автоматический бэкап данных",
      description: "Система автоматически сохраняет все данные в безопасном месте и восстанавливает их при необходимости."
    },
    {
      title: "🔒 Электронная подпись договоров",
      description: "Заключайте договоры с клиентами и партнерами в цифровом формате без лишней бюрократии."
    },
    {
      title: "🔗 Добавляйте туристов в систему в один клик, не вводя их данные вручную.",
      description: "Загружайте списки клиентов из Excel, Google Sheets или CSV за секунды."
    }
  ];

  return (
    <section className="bg-gray-50" id="advantage">
      <div className="mx-auto py-8 px-4">
        <div className="">
          <div className="items-center gap-8 lg:flex xl:gap-16">
            <div className="text-gray-500 sm:text-lg lg:w-3/6">
              <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 mb-10">
                Преимущества платформы
              </h2>
              <ul className="pt-8 space-y-5 border-t border-gray-200 my-7">
                {advantages.map((advantage) => (
                  <li className="">
                    <div className="flex gap-2">
                      <span className="text-base font-medium leading-tight text-gray-900">
                        {advantage.title}
                      </span>
                    </div>
                    <div>
                      {advantage.description}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="lg:w-3/6">
              <div>
                <img
                  className="w-full mb-4 rounded-lg lg:mb-0 lg:flex"
                  src="./images/dashboard2.png"
                />
              </div>
              <div className="mt-10">
                <img
                  className="w-full mb-4 rounded-lg lg:mb-0 lg:flex"
                  src="./images/hajjtravel-02.png"
                />
              </div>
              <div className="mt-10">
                <img
                  className="w-full mb-4 rounded-lg lg:mb-0 lg:flex"
                  src="./images/hajjtravel-03.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Advantages;
